import React from 'react';
import { PageLayout } from './PageLayout';

export const DatenschutzPage = () => {
    return (
        <PageLayout title="Datenschutzerklärung">
            <h3 className="text-xl font-semibold mt-0">1. Datenschutz auf einen Blick</h3>
            
            <h4 className="text-lg font-medium mt-6">Allgemeine Hinweise</h4>
            <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen 
                Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit 
                denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema 
                Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>

            <h3 className="text-xl font-semibold mt-8">2. Datenerfassung auf dieser Website</h3>
            
            <h4 className="text-lg font-medium mt-6">Wer ist verantwortlich für die Datenerfassung?</h4>
            <p>
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen 
                Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
            </p>

            <h4 className="text-lg font-medium mt-6">Wie erfassen wir Ihre Daten?</h4>
            <p>
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es 
                sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
            </p>
            <p>
                Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch 
                unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, 
                Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt 
                automatisch, sobald Sie diese Website betreten.
            </p>

            <h4 className="text-lg font-medium mt-6">Wofür nutzen wir Ihre Daten?</h4>
            <p>
                Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu 
                gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden 
                – jedoch nur mit Ihrer ausdrücklichen Einwilligung.
            </p>

            <h4 className="text-lg font-medium mt-6">Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>
            <p>
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck 
                Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die 
                Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur 
                Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft 
                widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der 
                Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein 
                Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>

            <h3 className="text-xl font-semibold mt-8">3. Hosting</h3>
            <p>
                Wir hosten die Inhalte unserer Website bei folgendem Anbieter: Netlify, Inc. Der Anbieter 
                ist ein US-amerikanisches Unternehmen. Die Datenübertragung in die USA wird auf die 
                Standardvertragsklauseln der EU-Kommission gestützt.
            </p>

            <h3 className="text-xl font-semibold mt-8">4. Cookies</h3>
            <p>
                Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die Ihr Webbrowser auf 
                Ihrem Endgerät speichert. Cookies helfen uns dabei, unser Angebot nutzerfreundlicher, 
                effektiver und sicherer zu machen.
            </p>
            <p>
                Einige Cookies sind "Session-Cookies". Solche Cookies werden nach Ende Ihrer Browser-Sitzung 
                von selbst gelöscht. Hingegen bleiben andere Cookies auf Ihrem Endgerät bestehen, bis Sie 
                diese selbst löschen oder bis sie automatisch gelöscht werden.
            </p>
            <p>
                Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert 
                werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle 
                oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des 
                Browsers aktivieren.
            </p>

            <h3 className="text-xl font-semibold mt-8">5. Analyse-Tools</h3>
            <p>
                Wir nutzen Analyse-Tools nur mit Ihrer ausdrücklichen Einwilligung. Sie können Ihre 
                Einwilligung jederzeit über die Cookie-Einstellungen widerrufen.
            </p>

            <h3 className="text-xl font-semibold mt-8">6. Ihre Rechte</h3>
            <p>
                Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten 
                personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung 
                sowie ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren 
                Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.
            </p>
            <ul className="list-disc list-inside mt-4 space-y-2">
                <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
                <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
                <li>Recht auf Löschung (Art. 17 DSGVO)</li>
                <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
            </ul>

            <h3 className="text-xl font-semibold mt-8">7. Kontakt</h3>
            <p>
                Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden:<br />
                E-Mail: info@detoxteetest.com
            </p>

            <p className="text-sm text-muted-foreground mt-8">
                Stand: Januar 2026
            </p>
        </PageLayout>
    );
};

